import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

import './styles/base.scss';
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap-css-only/css/bootstrap.min.css";
import "mdbreact/dist/css/mdb.css";
import './libs/fontawesome/fontawesome-all.min';
import './libs/fonts/jabrush.TTF';
import './libs/fonts/Potra.ttf';
import './libs/fonts/ka1.ttf';


import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js